import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.function.name.js";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { defineComponent, reactive, ref } from "vue";
import CryptoJS from "crypto-js";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

import axios from "@/api/axios";
import { useStore } from "vuex";
import { changeInfoTotal } from "@/hooks/changeInfoTotal";
import Cookies from "js-cookie";
import { deleteAllCookies } from "@/hooks/auth";
export default defineComponent({
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var router = useRouter();
    var store = useStore();
    var baseurl = process.env.VUE_APP_BASE_API;
    var dialogVisible = ref(false);
    var eln = ref(true);
    var form = reactive({
      username: "",
      password: "",
      words: ""
    });
    var accountSet = reactive({
      name: '',
      phone: "",
      unit: ""
    });
    var rules = {
      name: [{
        required: true,
        message: "请填写姓名",
        trigger: 'blur'
      }],
      phone: [{
        required: true,
        pattern: /^1[0-9]{10}$/,
        message: "请输入11位手机号码",
        trigger: 'blur'
      }],
      unit: [{
        required: true,
        message: "请填写单位",
        trigger: 'blur'
      }]
    };

    function chang() {
      verificationCode();
    } //加密


    function Encrypt(pwd) {
      var KEY = CryptoJS.enc.Utf8.parse("E9EFDA6C1567F9B6");
      var IV = CryptoJS.enc.Utf8.parse("85C155081E5CDD27");
      var key = KEY;
      var iv = IV;
      var pwdEncode = CryptoJS.enc.Utf8.parse(pwd);
      var encryptedPassword = CryptoJS.AES.encrypt(pwdEncode, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding
      });
      return CryptoJS.enc.Base64.stringify(encryptedPassword.ciphertext);
    } // let formbox = ref<HTMLElement|null>(null);


    var handleLogin = debounce( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var pages, _yield$globalProperti, code, datas, msg, instance, _yield$globalProperti2, data, account, userId, organizeId, username, userObj, tokens, isDemonstrate;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              pages = {};

              if (deploy.value) {
                pages = {
                  password: Encrypt(form.password),
                  username: form.username,
                  code: form.words,
                  uuid: uuid.value
                };
              } else {
                pages = {
                  password: Encrypt(form.password),
                  username: form.username
                };
              }

              _context.next = 4;
              return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["webLogin"](pages);

            case 4:
              _yield$globalProperti = _context.sent;
              code = _yield$globalProperti.code;
              datas = _yield$globalProperti.data;
              msg = _yield$globalProperti.msg;

              if (!(code == 0)) {
                _context.next = 33;
                break;
              }

              // sessionStorage.setItem("token", datas.access_token);
              // sessionStorage.setItem("refreshToken", datas.refresh_token);
              Cookies.set("token", datas.access_token);
              Cookies.set("refreshToken", datas.refresh_token);
              instance = axios();
              instance.defaults.headers.Authorization = datas.access_token; //储存用户信息

              _context.next = 15;
              return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getInformation"]();

            case 15:
              _yield$globalProperti2 = _context.sent;
              data = _yield$globalProperti2.data;
              account = data.account, userId = data.userId, organizeId = data.organizeId, username = data.username;
              userObj = {
                account: account,
                userId: userId,
                organizeId: organizeId,
                username: username
              };
              store.dispatch("user/setuser", userObj);
              tokens = datas.access_token;
              console.log(tokens, "tokens");
              _context.next = 24;
              return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getDemonstration"]({
                name: 'demo_enabled'
              });

            case 24:
              isDemonstrate = _context.sent;

              if (isDemonstrate.code == 0) {
                if (isDemonstrate.data.configValue == 'on') {
                  store.dispatch("system/setDemonstration", true);
                } else {
                  store.dispatch("system/setDemonstration", false);
                }
              }

              store.dispatch("webSocket/setNewWebsockety", {
                data: data.userId,
                token: tokens
              });
              sessionStorage.setItem("out", "0");
              ElMessage({
                message: "登录成功",
                type: "success"
              });
              changeInfoTotal("", "登录", 1);
              setTimeout(function () {
                router.replace({
                  path: "/loginChange"
                });
              }, 1000);
              _context.next = 35;
              break;

            case 33:
              ElMessage({
                message: msg,
                type: "warning"
              });
              chang();

            case 35:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), 800);

    function debounce(fn, wait) {
      var timers;
      return function () {
        if (timers) {
          clearTimeout(timers);
        }

        timers = setTimeout(function () {
          fn();
        }, wait);
      };
    } //表单验证


    var formbox = ref(null);

    function submitForm() {
      if (formbox.value) {
        formbox.value.validate(function (valid) {
          if (valid) {
            handleLogin();
          } else {
            return false;
          }
        });
      }
    }

    function closeAccount() {
      accountSet.name = '';
      accountSet.phone = "";
      accountSet.unit = "";
      dialogVisible.value = false;
    }

    var HeartFormRef = ref(null);

    function submitAccount() {
      if (HeartFormRef.value) {
        HeartFormRef.value.validate( /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
            var _yield$globalProperti3, code, data, jsonData;

            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    if (!valid) {
                      _context2.next = 10;
                      break;
                    }

                    _context2.next = 3;
                    return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["demonstrateLogin"]();

                  case 3:
                    _yield$globalProperti3 = _context2.sent;
                    code = _yield$globalProperti3.code;
                    data = _yield$globalProperti3.data;

                    if (code == 0) {
                      ElMessage({
                        message: "获取成功",
                        type: "success"
                      });
                      jsonData = JSON.parse(data);
                      form.username = jsonData.username;
                      form.password = jsonData.password;
                    }

                    dialogVisible.value = false;
                    _context2.next = 11;
                    break;

                  case 10:
                    return _context2.abrupt("return", false);

                  case 11:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }());
      }
    }

    function toindex() {
      router.push({
        path: "/"
      });
    }

    var rul = reactive({
      rules: {
        username: [{
          required: true,
          message: "请输入用户名",
          trigger: "blur"
        }],
        password: [{
          required: true,
          message: "请输入密码",
          trigger: "blur"
        }],
        words: [{
          required: true,
          message: "请输入验证码",
          trigger: "blur"
        }]
      }
    }); //判断该用户是否在线

    function tokenAlive() {
      return _tokenAlive.apply(this, arguments);
    }

    function _tokenAlive() {
      _tokenAlive = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _yield$globalProperti5, msg;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["tokenAlive"]();

              case 2:
                _yield$globalProperti5 = _context4.sent;
                msg = _yield$globalProperti5.msg;

                if (msg == "unauthorized") {
                  // sessionStorage.clear();
                  deleteAllCookies();
                }

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _tokenAlive.apply(this, arguments);
    }

    tokenAlive(); //验证码

    var imgsurl = ref("");
    var uuid = ref("");

    function verificationCode() {
      return _verificationCode.apply(this, arguments);
    }

    function _verificationCode() {
      _verificationCode = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var lis;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["verificationCode"]();

              case 2:
                lis = _context5.sent;

                if (lis.code == 0) {
                  imgsurl.value = "data:image/gif;base64," + lis.data.img;
                  uuid.value = lis.data.uuid;
                }

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      return _verificationCode.apply(this, arguments);
    }

    verificationCode();
    var deploy = ref(false);

    function verideploy() {
      return _verideploy.apply(this, arguments);
    }

    function _verideploy() {
      _verideploy = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var lis;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["verideploy"]();

              case 2:
                lis = _context6.sent;

                if (lis.code == 0) {
                  deploy.value = lis.data;
                }

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      return _verideploy.apply(this, arguments);
    }

    verideploy();

    function getAccount() {
      dialogVisible.value = true;
    } //获取是否展示演示账号


    var showDemonstration = ref(false);

    var getDemonstration = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _ref4;

        var _yield$globalProperti4, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getDemonstration"]({
                  name: 'demo_display'
                });

              case 2:
                _yield$globalProperti4 = _context3.sent;
                data = _yield$globalProperti4.data;
                showDemonstration.value = (_ref4 = data.configValue == 'on') !== null && _ref4 !== void 0 ? _ref4 : false;

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function getDemonstration() {
        return _ref3.apply(this, arguments);
      };
    }();

    getDemonstration();
    return {
      // ...toRefs(form),
      form: form,
      handleLogin: handleLogin,
      toindex: toindex,
      baseurl: baseurl,
      rul: rul,
      formbox: formbox,
      submitForm: submitForm,
      Encrypt: Encrypt,
      eln: eln,
      chang: chang,
      verificationCode: verificationCode,
      imgsurl: imgsurl,
      uuid: uuid,
      deploy: deploy,
      verideploy: verideploy,
      dialogVisible: dialogVisible,
      getAccount: getAccount,
      accountSet: accountSet,
      rules: rules,
      submitAccount: submitAccount,
      HeartFormRef: HeartFormRef,
      closeAccount: closeAccount,
      showDemonstration: showDemonstration
    };
  }
});